import React,{findDOMNode} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ReactDOM from 'react-dom';

export default class Modal extends React.Component {
	constructor() {
		super();
	}
	componentDidMount() {

	}

	componentWillUnmount() {

	}



	render() {

		let backdrop_style = {};
		if(this.props.zIndex) {
			backdrop_style.zIndex = this.props.zIndex;
		}

	return (
		<div className="fullscreen-overlay">

			<ReactCSSTransitionGroup
			transitionName="modal-backdrop"
			transitionEnterTimeout={200}
			transitionLeaveTimeout={200}
			transitionAppear={true}
      		transitionAppearTimeout={200}
			>
				<div className="fullscreen-backdrop" style={backdrop_style}></div>
				{
					this.props.hideCloseButton
					?
						null
					:
                        <div className="close-btn" onClick={this.props.closePortal}><i className="icon fa-close"></i></div>
				}
			</ReactCSSTransitionGroup>

			<div className="fullscreen-wrapper">
				<ReactCSSTransitionGroup
					transitionName="zoom-in"
					transitionEnterTimeout={200}
					transitionLeaveTimeout={200}
					transitionAppear={true}
		      		transitionAppearTimeout={200}>
					{this.props.children}
				</ReactCSSTransitionGroup>
			</div>

		</div>
	);
	}

}



// WEBPACK FOOTER //
// ./components/FullScreenOverlay.js